<div class="card">
  <app-header
    titulo="Dashboard SmartInteg"
    descricao="Visão geral do sistema de integração de dados">
  </app-header>

  <!-- Cards de Resumo -->
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-3">
      <p-card>
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-500 font-medium mb-3">Provedores</span>
            <div class="text-900 font-medium text-xl">{{ stats.provedores }}</div>
          </div>
          <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
            <i class="pi pi-database text-blue-500 text-xl"></i>
          </div>
        </div>
      </p-card>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <p-card>
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-500 font-medium mb-3">Processos</span>
            <div class="text-900 font-medium text-xl">{{ stats.processos }}</div>
          </div>
          <div class="flex align-items-center justify-content-center bg-orange-100 border-round" style="width:2.5rem;height:2.5rem">
            <i class="pi pi-cog text-orange-500 text-xl"></i>
          </div>
        </div>
      </p-card>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <p-card>
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-500 font-medium mb-3">Recursos</span>
            <div class="text-900 font-medium text-xl">{{ stats.recursos }}</div>
          </div>
          <div class="flex align-items-center justify-content-center bg-cyan-100 border-round" style="width:2.5rem;height:2.5rem">
            <i class="pi pi-list text-cyan-500 text-xl"></i>
          </div>
        </div>
      </p-card>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <p-card>
        <div class="flex justify-content-between align-items-center">
          <div>
            <span class="block text-500 font-medium mb-3">Execuções Hoje</span>
            <div class="text-900 font-medium text-xl">{{ stats.execucoes }}</div>
          </div>
          <div class="flex align-items-center justify-content-center bg-purple-100 border-round" style="width:2.5rem;height:2.5rem">
            <i class="pi pi-play text-purple-500 text-xl"></i>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <!-- Tabelas -->
  <div class="grid mt-2">
    <div class="col-12 lg:col-6">
      <p-panel header="Últimas Execuções">
        <p-table [value]="ultimasExecucoes" [loading]="loading" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>Processo</th>
              <th>Data</th>
              <th>Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-execucao>
            <tr>
              <td>{{ execucao.processoNome }}</td>
              <td>{{ execucao.data | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>
                <p-tag [severity]="execucao.sucesso ? 'success' : 'danger'" [value]="execucao.sucesso ? 'Sucesso' : 'Falha'"></p-tag>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="3" class="text-center">Nenhuma execução recente.</td></tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
    <div class="col-12 lg:col-6">
      <p-panel header="Processos Ativos">
        <p-table [value]="processosAtivos" [loading]="loading" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Ações</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-processo>
            <tr>
              <td>{{ processo.nome }}</td>
              <td>{{ processo.descricao }}</td>
              <td>
                <button pButton pRipple icon="pi pi-play" class="p-button-rounded p-button-success p-button-text"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="3" class="text-center">Nenhum processo ativo.</td></tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>

</div>
